<template>
  <SidebarWhiteLabel v-if="hideBranding && isWhiteLabelHideNavigation && !isLoggedIn" />
  <Sidebar v-else />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';

import { useBranding } from '@/composables/useBranding';
import { useFeatures } from '@/composables/useFeatures';
import { useUserStore } from '@/store/useUserStore';
import Sidebar from './Sidebar.vue';
import SidebarWhiteLabel from './SidebarWhiteLabel.vue';

const { hideBranding } = useBranding();
const { getItemFeature } = useFeatures();
const isWhiteLabelHideNavigation = getItemFeature('white-label-hide-navigation', false);
const { isLoggedIn } = storeToRefs(useUserStore());
</script>
